"use client";

import Banner from "./_components/banner";
import FormWrapper from "./_components/form-wrapper";

const FlightReqPage = () => {

	return (
		<>
			<Banner />

			<FormWrapper />
		</>
	);
};

export default FlightReqPage;